<template>
  <!-- 模板内容保持不变 -->
  <my-header></my-header>
  <div class="product-list-body">
    <!-- 页面路径导航 -->
    <div class="product-page-title-body">
      <div class="product-page-title">
        <h5>{{ $t('common.home') }} > {{ currentCategory.name }}</h5>
      </div>
    </div>

    <!-- 分类选择和标题区域 -->
    <div class="list-header">
      <div class="category-info">
        <h3 v-if="false">{{ currentCategory.name }}</h3>
      </div>
      <div class="category-selector">
        <el-select
            @change="changeCategory"
            v-model="selectedCategoryId"
            :placeholder="$t('productList.selectCategory')"
            size="small"
            style="width: 240px"
        >
          <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.id"
          />
        </el-select>
      </div>
    </div>

    <!-- 产品系列展示 -->
    <div class="product-series" v-for="series in seriesList" :key="series.id">
      <div class="series-title" v-if="filteredProductsBySeries(series.id).length>0">
        <h4>{{ series.name }}</h4>
      </div>
      <div class="product-grid" v-if="filteredProductsBySeries(series.id).length>0">
        <ProductCard
            v-for="product in filteredProductsBySeries(series.id)"
            :key="product.id"
            :product="product"
            @click="navigateToProduct(product.id)"
            @mouseenter="handleProductHover(product.id)"
            @mouseleave="handleProductUnhover(product.id)"
        />
      </div>
    </div>
  </div>
  <my-foot></my-foot>
</template>

<script>
import router from '@/router';
import MyHeader from "@/components/MyHeader";
import MyFoot from "@/components/MyFoot";
import ProductCard from "@/components/ProductCard";

export default {
  name: "PdtList",
  components: {
    MyHeader,
    MyFoot,
    ProductCard
  },
  data() {
    return {
      selectedCategoryId: 0,
      products: []
    };
  },
  computed: {
    // 分类列表（国际化处理）
    categories() {
      return [
        {
          id: 0,
          name: this.$t('productCategories.allProducts'),
          description: this.$t('productCategories.allProductsDesc')
        },
        {
          id: 1,
          name: this.$t('categories.miniLightBars'),
          description: this.$t('productCategories.miniLightBarsDesc')
        },
        {
          id: 2,
          name: this.$t('categories.fullLightBars'),
          description: this.$t('productCategories.fullLightBarsDesc')
        },
        {
          id: 3,
          name: this.$t('categories.visorLightBars'),
          description: this.$t('productCategories.visorLightBarsDesc')
        },
        {
          id: 4,
          name: this.$t('categories.deckDashLights'),
          description: this.$t('productCategories.deckDashLightsDesc')
        },
        {
          id: 5,
          name: this.$t('categories.grilleSurfaceMounts'),
          description: this.$t('productCategories.grilleSurfaceMountsDesc')
        },
        {
          id: 6,
          name: this.$t('categories.siren'),
          description: this.$t('productCategories.sirenDesc')
        },
        {
          id: 7,
          name: this.$t('categories.trafficAdvisors'),
          description: this.$t('productCategories.trafficAdvisorsDesc')
        },
        {
          id: 8,
          name: this.$t('categories.mountingBrackets'),
          image: require('@/assets/product/PJ/QDSTVB2.png')
        }
      ];
    },

    // 系列列表（国际化处理）
    seriesList() {
      return [
        { id: 0, name: ""},
        { id: 1, name: this.$t('productSeries.tirSeries')},
        { id: 2, name: this.$t('productSeries.linearSeries')},
        { id: 3, name: this.$t('productSeries.switchBoxes')},
        { id: 4, name: this.$t('categories.siren')},
        { id: 5, name: this.$t('categories.mountingBrackets')},
      ];
    },

    // 当前选中分类的详细信息
    currentCategory() {
      return this.categories.find(category => category.id === this.selectedCategoryId) || this.categories[0];
    },

    // 过滤后的产品列表
    filteredProducts() {
      if (this.selectedCategoryId === 0) {
        return this.products;
      }
      return this.products.filter(product => product.categoryId === this.selectedCategoryId);
    },

    // 根据系列ID获取产品
    filteredProductsBySeries() {
      return (seriesId) => {
        return this.filteredProducts.filter(product => product.seriesId === seriesId);
      };
    }
  },
  methods: {
    // 创建产品数据（使用国际化文本）
    createProduct(id, baseNameKey, size, categoryId, imagesDir, seriesId, type, seriesNameKey) {
      return {
        id,
        categoryId,
        seriesId,
        name: this.$t('productNames.' + baseNameKey, {
          series: this.$t('productSeries.' + seriesNameKey),
          size: size
        }),
        defaultImage: require(`@/assets/product/touming/${type}/${imagesDir}7.webp`),
        hoverImage: require(`@/assets/product/touming/${type}/${imagesDir}6.webp`),
        isHovered: false,
        imageList: [1, 0, 2, 3, 4].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          id: i
        }))
      };
    },

    // 其他产品创建方法保持不变...
    createProductGLight(id, nameKey, size, categoryId, imagesDir, seriesId, type, seriesNameKey) {
      console.log(seriesNameKey)
      return {
        id,
        categoryId,
        seriesId,
        name: this.$t('productNames.' + nameKey),
        defaultImage: require(`@/assets/product/touming/${type}/${imagesDir}6.webp`),
        hoverImage: require(`@/assets/product/touming/${type}/${imagesDir}7.webp`),
        isHovered: false,
        imageList: [1, 0, 2, 3].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          id: i
        }))
      };
    },

    createProductGDLight(id, nameKey, size, categoryId, imagesDir, seriesId, type, seriesNameKey) {
      console.log(seriesNameKey)
      return {
        id,
        categoryId,
        seriesId,
        name: this.$t('productNames.' + nameKey),
        defaultImage: require(`@/assets/product/touming/${type}/${imagesDir}6.webp`),
        hoverImage: require(`@/assets/product/touming/${type}/${imagesDir}7.webp`),
        isHovered: false,
        imageList: [1, 0, 2, 3].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          id: i
        }))
      };
    },

    createProductJBQLight(id, nameKey, size, categoryId, imagesDir, seriesId, type, seriesNameKey) {
      console.log(seriesNameKey)
      return {
        id: id,
        categoryId,
        seriesId,
        name: this.$t('productNames.' + nameKey),
        defaultImage: require(`@/assets/product/touming/${type}/${imagesDir}4.webp`),
        hoverImage: require(`@/assets/product/touming/${type}/${imagesDir}5.webp`),
        isHovered: false,
        imageList: [0,1,2,3,4].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          id: i
        }))
      };
    },

    createProductZYBLight(id, nameKey, size, categoryId, imagesDir, seriesId, type, seriesNameKey) {
      console.log(seriesNameKey)
      return {
        id: id,
        categoryId,
        seriesId,
        name: this.$t('productNames.' + nameKey, { size: size }),
        defaultImage: require(`@/assets/product/touming/${type}/${imagesDir}1.webp`),
        hoverImage: require(`@/assets/product/touming/${type}/${imagesDir}4.webp`),
        isHovered: false,
        imageList: [0,1,2,3,4].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i+1}.webp`),
          id: i
        }))
      };
    },

    createProductZJ(id, nameKey, size, categoryId, imagesDir, seriesId, type, seriesNameKey) {
      console.log(seriesNameKey)
      return {
        id: id,
        categoryId,
        seriesId,
        name: this.$t('productNames.' + nameKey),
        defaultImage: require(`@/assets/product/${type}/${imagesDir}1.webp`),
        hoverImage: require(`@/assets/product/${type}/${imagesDir}2.webp`),
        isHovered: false,
        imageList: [0,1,2,3].map((i) => ({
          src: require(`@/assets/product/${type}/${imagesDir}${i+1}.webp`),
          thumbnail: require(`@/assets/product/${type}/${imagesDir}${i+1}.webp`),
          id: i
        }))
      };
    },

    createProductZJ2(id, nameKey, size, categoryId, imagesDir, seriesId, type, seriesNameKey) {
      console.log(seriesNameKey)
      return {
        id: id,
        categoryId,
        seriesId,
        name: this.$t('productNames.' + nameKey),
        defaultImage: require(`@/assets/product/${type}/${imagesDir}5.webp`),
        hoverImage: require(`@/assets/product/${type}/${imagesDir}4.webp`),
        isHovered: false,
        imageList: [0,1,2,3,4].map((i) => ({
          src: require(`@/assets/product/${type}/${imagesDir}${i+1}.webp`),
          thumbnail: require(`@/assets/product/${type}/${imagesDir}${i+1}.webp`),
          id: i
        }))
      };
    },

    // 初始化产品数据
    initializeProducts() {
      this.products = [
        this.createProduct(0, "miniLedLightBar", 18, 1, "18T", 1, "T", "sy001Tir"),
        this.createProduct(1, "miniLedLightBar", 27, 1, "27T", 1, "T", "sy001Tir"),
        this.createProduct(2, "fullSizeLedLightBar", 36, 2, "36T", 1, "T", "sy001Tir"),
        this.createProduct(3, "fullSizeLedLightBar", 47, 2, "47T", 1, "T", "sy001Tir"),
        this.createProduct(4, "fullSizeLedLightBar", 55, 2, "55T", 1, "T", "sy001Tir"),
        this.createProduct(5, "fullSizeLedLightBar", 63, 2, "63T", 1, "T", "sy001Tir"),
        this.createProduct(6, "fullSizeLedLightBar", 71, 2, "71T", 1, "T", "sy001Tir"),

        // 其他产品保持不变...
        this.createProduct(7, "miniLedLightBar", 18, 1, "18L", 2, "L", "sy001Linear"),
        this.createProduct(8, "miniLedLightBar", 27, 1, "27L", 2, "L", "sy001Linear"),
        this.createProduct(9, "fullSizeLedLightBar", 36, 2, "36L", 2, "L", "sy001Linear"),
        this.createProduct(10, "fullSizeLedLightBar", 47, 2, "47L", 2, "L", "sy001Linear"),
        this.createProduct(11, "fullSizeLedLightBar", 55, 2, "55L", 2, "L", "sy001Linear"),

        this.createProductGLight(12, "g003LinearGrilleLight", 3, 5, "Z3L", 2, "L", "linearSeries"),
        this.createProductGLight(13, "g004LinearGrilleLight", 4, 5, "Z4L", 2, "L", "linearSeries"),
        this.createProductGLight(14, "g006LinearGrilleLight", 6, 5, "Z6L", 2, "L", "linearSeries"),
        this.createProductGLight(15, "g003TirGrilleLight", 3, 5, "Z3T", 1, "T", "tirSeries"),
        this.createProductGLight(16, "g004TirGrilleLight", 4, 5, "Z4T", 1, "T", "tirSeries"),
        this.createProductGLight(17, "g006TirGrilleLight", 6, 5, "Z6T", 1, "T", "tirSeries"),

        this.createProductGDLight(18, "hbStt1", 1, 4, "G1", 1, "T", "tirSeries"),
        this.createProductGDLight(19, "hbStt2", 2, 4, "G2", 1, "T", "tirSeries"),
        this.createProductGDLight(20, "hbStt4", 4, 4, "G4", 1, "T", "tirSeries"),
        this.createProductGDLight(21, "hbStt6", 1, 7, "G6", 1, "T", "tirSeries"),
        this.createProductGDLight(22, "hbStt8", 1, 7, "G8", 1, "T", "tirSeries"),

        this.createProduct(23, "fullSizeLedLightBar", 36, 2, "Y236T", 1, "T", "sy002Tir"),
        this.createProduct(24, "fullSizeLedLightBar", 47, 2, "Y247T", 1, "T", "sy002Tir"),

        this.createProductZYBLight(25, "syRt8VisorLightBar", 4, 3, "ZY4", 1, "T", "tirSeries"),
        this.createProductZYBLight(26, "syRt10VisorLightBar", 5, 3, "ZY5", 1, "T", "tirSeries"),

        this.createProductZYBLight(27, "hSa100", 5, 6, "A1", 4, "JBQ", "tirSeries"),
        this.createProductZYBLight(28, "hSb200", 5, 6, "B2", 4, "JBQ", "tirSeries"),
        this.createProductZYBLight(29, "hSm100", 5, 6, "M1", 4, "JBQ", "tirSeries"),
        this.createProductZYBLight(30, "hPa100", 5, 6, "PA1", 4, "JBQ", "tirSeries"),
        this.createProductZYBLight(31, "hSv100", 5, 6, "V1", 4, "JBQ", "tirSeries"),

        this.createProductZJ(32, "qAdhb", 5, 8, "QADHB", 5, "PJ", "mountingBrackets"),
        this.createProductZJ(33, "qDstvb", 5, 8, "QDSTVB", 5, "PJ", "mountingBrackets"),
        this.createProductZJ(34, "qHmb", 5, 8, "QHMB", 5, "PJ", "mountingBrackets"),
        this.createProductZJ(35, "qSstb", 5, 8, "QSSTB", 5, "PJ", "mountingBrackets"),
        this.createProductZJ(36, "qSthb", 5, 8, "QSTHB", 5, "PJ", "mountingBrackets"),
        this.createProductZJ2(37, "qLpb", 5, 8, "QLPB", 5, "PJ", "mountingBrackets"),
        this.createProductZJ2(38, "qRve", 5, 8, "QRVE", 5, "PJ", "mountingBrackets"),
      ];
    },

    // 其他方法保持不变...
    navigateToProduct(id) {
      const product = this.products.find(p => p.id === id);
      if (product) {
        router.push({
          name: "Desc", // 你的产品详情页路由name
          query: { pid:  product.id } // 传递产品ID（如当前产品的id）
        });
      }
    },

    changeCategory(categoryId) {
      this.selectedCategoryId = categoryId;
    },

    handleProductHover(id) {
      this.updateProductHoverState(id, true);
    },

    handleProductUnhover(id) {
      this.updateProductHoverState(id, false);
    },

    updateProductHoverState(id, isHovered) {
      const product = this.products.find(p => p.id === id);
      if (product) {
        product.isHovered = isHovered;
      }
    }
  },
  created() {
    // 初始化产品数据
    this.initializeProducts();

    // 从路由参数获取初始分类
    const categoryId = parseInt(this.$route.params.categoryId) || 0;
    if (this.categories.some(c => c.id === categoryId)) {
      this.selectedCategoryId = categoryId;
    }

    // 监听语言变化事件
    this.$i18n.localeChanged = () => {
      // 语言变化时重新初始化产品数据
      this.initializeProducts();
    };
    window.scrollTo(0, 0);
  },
  watch: {
    '$i18n.locale'(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        // 重新初始化产品数据（使用新语言）
        this.initializeProducts();
        // 强制组件重新渲染（确保视图更新）
        this.$forceUpdate();
      }
    },
    // 监听路由变化，更新分类
    '$route.params.categoryId': {
      handler(newId) {
        const categoryId = parseInt(newId) || 0;
        if(this.categories.some(c => c.id === categoryId)) {
          this.selectedCategoryId = categoryId;
        }
      },
      immediate: false
    }
  }
}
</script>

<style scoped>
/* 样式保持不变 */
.product-list-body {
  padding: 20px 0;
}

.product-page-title-body {
  background-color: #f5f5f5;
}

.product-page-title {
  width: 80%;
  margin: 0 auto;
  text-align: left;
  line-height: 4;
}

.list-header {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.category-info {
  flex: 1;
}

.category-info h3 {
  margin-bottom: 8px;
}

.category-selector {
  text-align: right;
}

.series-title {
  width: 80%;
  margin: 0 auto;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  margin-top: 30px;
}

.product-grid {
  width: 80%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 30px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .list-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .category-selector {
    text-align: left;
    margin-top: 15px;
  }

  .product-grid {
    grid-template-columns: 1fr;
  }
}
</style>
